/* Cart drawer extras: one-tap add for the upsell rail and the pair nudge.
   Persistent delegated listener — survives the drawer's Section Rendering
   API re-renders (same pattern as the free-shipping bar). */
(() => {
  if (window.SFCartPlus) return;
  window.SFCartPlus = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cp-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = '…';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(btn.dataset.cpAdd),
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) {
          btn.disabled = false;
          btn.textContent = original;
          return;
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();
